import { Container, Grid,Typography } from '@mui/material';
import React from 'react';
import ServiceCards from './servicecards';
import ServiceStepper from './servicestepper';

const OurService = () => {
  return (
    <Container sx={{ paddingTop: '40px', paddingBottom: '40px' }}>
      <Typography variant="h4" align="center" gutterBottom sx={{marginBottom:"50px",color:"rgb(29,35,42)"}} className='component'>
        Our Service and <span style={{background:"linear-gradient(-96deg, rgb(194 183 183 / 0%) 0%, rgb(255 249 220 / 4%) 28%, rgb(255, 162, 49) 100%, rgb(255 255 255 / 0%) 100%)",fontWeight:"normal"}}>How It Works?</span>
      </Typography>
      <Grid container spacing={4} alignItems={"center"}>
        <Grid item xs={12} md={6}>
          <ServiceCards />
        </Grid>
        <Grid item xs={12} md={6}>
          <ServiceStepper />
        </Grid>
      </Grid>
    </Container>
  );
};

export default OurService;

